import BaseTab from "./BaseTabs";

export default BaseTab